import { platformCardRadius, platformHeroBg } from '../PlatformShared'
import { pricingContainer, PricingButton } from './Shared'
export default function PricingPlans({ plans, billing, onTalkToSales }) {
    return (
        <section
            aria-label="Platform plans"
            className={`${platformHeroBg} -mt-20 pb-12 pt-4`}>
            <div
                className={`${pricingContainer} grid gap-[18px] md:grid-cols-2 lg:grid-cols-4`}>
                {plans.map((plan) => (
                    <article
                        key={plan.id}
                        data-plan={plan.id}
                        className={`min-w-0 ${platformCardRadius} border bg-white px-[22px] py-[26px] transition hover:-translate-y-1 hover:shadow-lg ${
                            plan.id === 'growth'
                                ? 'border-secondary/30 shadow-lg'
                                : 'border-black/10'
                        }`}>
                        <h2 className="mb-2.5 text-[13px] font-extrabold uppercase tracking-wide">
                            {plan.name}
                        </h2>
                        <div
                            aria-live="polite"
                            aria-atomic="true"
                            className="min-h-[66px]">
                            <p className="flex items-baseline gap-1">
                                <span
                                    className={`${
                                        plan.period
                                            ? 'text-[38px]'
                                            : 'text-[28px]'
                                    } font-extrabold tracking-tight`}>
                                    {plan[billing]}
                                </span>
                                <span className="text-[13px] font-semibold text-olm-gray">
                                    {plan.period}
                                </span>
                            </p>
                            <p className="min-h-[20px] text-xs text-olm-gray">
                                {billing === 'annual' ? plan.annualNote : ''}
                            </p>
                        </div>
                        <p
                            className={`mb-2 min-h-[50px] text-[13px] leading-relaxed text-olm-gray ${
                                plan.id === 'enterprise' ? 'mt-[10px]' : ''
                            }`}>
                            {plan.description}
                        </p>
                        <PricingButton
                            {...plan.cta}
                            full
                            onClick={
                                plan.id === 'enterprise'
                                    ? onTalkToSales
                                    : undefined
                            }
                        />
                        <p className="mb-3 mt-3 flex items-start gap-2 text-xs font-semibold leading-relaxed text-olm-gray">
                            <span
                                aria-hidden="true"
                                className="mt-1.5 h-[5px] w-[5px] shrink-0 rounded-full bg-primary"
                            />
                            {plan.volume}
                        </p>
                        <div className="border-t border-black/10 pt-[18px]">
                            {plan.intro && (
                                <p className="mb-3 text-[13px] font-bold">
                                    {plan.intro}
                                </p>
                            )}
                            <ul className="grid gap-2.5">
                                {plan.features.map((feature) => (
                                    <li
                                        key={feature}
                                        className="flex items-start gap-2 text-xs leading-relaxed">
                                        <span
                                            aria-hidden="true"
                                            className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-50 text-[10px] font-bold text-olm-green">
                                            ✓
                                        </span>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    )
}
